<template>
  <DefaultLayout>
    <template #sidebar="{ collapsed }">
      <UDashboardSearchButton :collapsed="collapsed" tooltip class="bg-transparent ring-default" />
      <UNavigationMenu
        :collapsed="collapsed"
        :items="links"
        orientation="vertical"
        tooltip
        popover
      />
    </template>

    <template #default>
      <slot />
    </template>

  </DefaultLayout>
</template>

<script setup>
import DefaultLayout from './default.vue'

const links = [{
  id: 'home',
  label: 'Dashboard',
  icon: 'i-ph-house-line-duotone',
  to: '/admin',
  exact: true,
}, {
  id: 'users',
  label: 'Utilisateurs',
  icon: 'i-ph-user-duotone',
  to: '/admin/user',
}, {
  id: 'organizations',
  label: 'Structures',
  icon: 'i-ph-users-three-duotone',
  to: '/admin/organization',
}, {
  id: 'missions',
  label: 'Missions',
  icon: 'i-ph-megaphone-duotone',
  defaultOpen: true,
  children: [
    {
      label: 'Missions des structures',
      to: '/admin/mission',
    },
    {
      label: 'Modèles de mission',
      to: '/admin/mission-template',
    },
  ],
}, {
  id: 'ratings',
  label: 'Recommandations',
  to: '/admin/rating',
  icon: 'i-ph-thumbs-up-duotone',
}, {
  id: 'groups',
  label: 'Réseaux',
  icon: 'i-ph-share-network-duotone',
  to: '/admin/group',
}, {
  id: 'platforms',
  label: 'Plateformes',
  to: '/admin/platform',
  icon: 'i-ph-globe-duotone',
}, {
  id: 'billing',
  label: 'Facturation',
  to: '/admin/billing',
  icon: 'i-ph-bank-duotone',
}, {
  id: 'campaigns',
  label: 'Campagnes Mail',
  to: '/admin/message-campaign',
  icon: 'i-ph-paper-plane-right-duotone',
}]

</script>
